import Cookies from 'js-cookie';
import { notification } from 'antd';
import actions from './actions';
import {
  clearAuthSessionCookies,
  clearAuthTokens,
  getRefreshToken,
  persistTokensFromLogin,
  unwrapAuthResponse,
} from '../../config/authSession';
import { DataService, resetRefreshFailureStreak } from '../../config/dataService/dataService';
import { getItem } from '../../utility/cookieStorage';
import PermissionService from '../../services/permissionService';
import sessionRefreshService from '../../services/sessionRefreshService';

const { loginBegin, loginSuccess, loginErr, logoutBegin, logoutSuccess, logoutErr } = actions;

const login = (values, callback) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const response = await DataService.post('/v1/auth/login', values);
      const loginPayload = unwrapAuthResponse(response.data);

      if (response.data.errors) {
        dispatch(loginErr(response.data.errors));
        return;
      }
      if (!loginPayload.token) {
        dispatch(loginErr('Login failed'));
        return;
      }

      persistTokensFromLogin(response.data);
      if (!getRefreshToken()) {
        clearAuthTokens();
        dispatch(loginErr('Login failed: missing refresh token'));
        return;
      }
      resetRefreshFailureStreak();
      Cookies.set('logedIn', true);
      if (values.remember_me) {
        Cookies.set('remember_me', 'true', { expires: 30 });
      } else {
        Cookies.remove('remember_me');
      }
      const profile = await DataService.get('/v1/profile');
      if (profile.data.errors) {
        dispatch(loginErr(profile.data.errors));
      } else {
        const user = {
          name: profile.data.data.name,
          lastname: profile.data.data.lastname,
          id: profile.data.data.id,
          avatar: profile.data.data.avatar,
          type: profile.data.data.type,
          currentOrgId: profile.data.data.current_organization_id,
        };
        Cookies.set('user', JSON.stringify(user));
        Cookies.set('currentOrganizationId', profile.data.data.current_organization_id);

        try {
          await PermissionService.initializePermissions(profile.data.data.current_organization_id);
        } catch (permissionError) {
          // eslint-disable-next-line no-console
          console.warn('Failed to load user permissions on login:', permissionError);
        }
      }
      const environment = await DataService.get('/v1/environment');
      if (environment.data.errors) {
        dispatch(loginErr(environment.data.errors));
      } else {
        Cookies.set('environemnt', JSON.stringify(environment.data));
      }
      dispatch(loginSuccess(true));
      if (values.remember_me) {
        sessionRefreshService.start(typeof loginPayload.expires_in === 'number' ? loginPayload.expires_in : undefined);
      }
      callback();
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const register = (values, callback, errorCallback) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const response = await DataService.post('/v1/auth/register', values);
      // console.log(response.data.success);
      if (response.data.success === true) {
        notification.success({
          message: 'Register',
          description: 'Register success.',
        });
        if (callback) {
          callback(); // Call the callback function to handle redirection
        }
      }
    } catch (err) {
      // 422 validation errors için özel işlem
      if (err.response && err.response.status === 422) {
        const errorData = err.response.data;
        if (errorCallback) {
          errorCallback(errorData); // Field-specific hataları component'e gönder
        } else {
          // Fallback: genel hata mesajı
          notification.error({
            message: 'Register',
            description: errorData.message || 'Validation failed.',
          });
        }
      } else {
        notification.error({
          message: 'Register',
          description: 'Register failed.',
        });
      }
      dispatch(loginErr(err));
    }
  };
};

const logOut = (callback) => {
  return async (dispatch) => {
    dispatch(logoutBegin());
    try {
      const token = getItem('access_token');
      if (token) {
        try {
          await DataService.post('/v1/auth/logout', {}, { Authorization: `Bearer ${token}` });
        } catch (apiErr) {
          // API hata verse bile access + refresh istemciden silinir
        }
      }
      clearAuthSessionCookies();
      sessionRefreshService.stop();
      PermissionService.clearPermissions();

      dispatch(logoutSuccess(false));
      if (callback) {
        callback();
      }
    } catch (err) {
      clearAuthSessionCookies();
      sessionRefreshService.stop();
      PermissionService.clearPermissions();
      dispatch(logoutErr(err));
      if (callback) {
        callback();
      }
    }
  };
};

export { login, logOut, register };
